<template>
  <a-modal
    :visible="visible"
    :title="title"
    @cancel="handleCancel"
    width="900px"
  >
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item :label="$t('直播课程.章节名称')">
              <a-input v-model="queryParam.chapterName" @pressEnter="handleQuery" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
              <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operations">
      <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['livecourse:liveCourseChapter:add']">
        <a-icon type="plus" />{{$t('通用.按钮.新增')}}
      </a-button>
      <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['livecourse:liveCourseChapter:remove']">
        <a-icon type="delete" />{{$t('通用.按钮.删除')}}
      </a-button>
    </div>
    <!-- 增加修改 -->
    <create-form ref="createForm" :courseId="courseId" :courseList="courseList" @ok="getList" />
    <!-- 小节管理 -->
    <section-modal v-if="sectionModalVisible" ref="sectionModal" :courseId="courseId" :chapterId="selectedChapterId" :courseList="courseList" :chapterList="chapterList" :visible="sectionModalVisible" @cancel="sectionModalVisible = false" />
    <a-table
      :loading="loading"
      rowKey="id"
      :columns="columns"
      :data-source="list"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      :pagination="false"
      :bordered="tableBordered"
    >
      <span slot="createTime" slot-scope="text, record">
        {{ parseTime(record.createTime) }}
      </span>
      <span slot="operation" slot-scope="text, record">
        <a @click="$refs.createForm.handleUpdate(record)" v-hasPermi="['livecourse:liveCourseChapter:edit']">
          <a-icon type="edit" />{{$t('通用.按钮.修改')}}
        </a>
        <a-divider type="vertical" />
        <a @click="handleDelete(record)" v-hasPermi="['livecourse:liveCourseChapter:remove']">
          <a-icon type="delete" />{{$t('通用.按钮.删除')}}
        </a>
        <a-divider type="vertical" />
        <a @click="handleSection(record)" v-hasPermi="['livecourse:liveCourseSection:list']">
          <a-icon type="list" />{{$t('直播课程.小节管理')}}
        </a>
      </span>
    </a-table>
    <a-pagination
      class="ant-table-pagination"
      show-size-changer
      show-quick-jumper
      :current="queryParam.pageNum"
      :total="total"
      :page-size="queryParam.pageSize"
      @showSizeChange="onShowSizeChange"
      @change="changeSize"
    />
  </a-modal>
</template>

<script>
import { pageLiveCourseChapter, delLiveCourseChapter } from '@/api/livecourse/liveCourseChapter'
import { listLiveCourse } from '@/api/livecourse/liveCourse'
import CreateForm from '@/views/livecourse/liveCourseChapter/modules/CreateForm'
import SectionModal from './SectionModal'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'ChapterModal',
  components: {
    CreateForm,
    SectionModal
  },
  mixins: [tableMixin],
  props: {
    courseId: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: '',
      list: [],
      courseList: [],
      chapterList: [],
      loading: false,
      total: 0,
      selectedRowKeys: [],
      multiple: true,
      selectedChapterId: null,
      sectionModalVisible: false,
      queryParam: {
        courseId: this.courseId,
        chapterName: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        { title: this.$t('直播课程.章节数'), dataIndex: 'chapterNumber' },
        { title: this.$t('直播课程.章节名称'), dataIndex: 'chapterName' },
        { title: this.$t('直播课程.创建时间'), dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' } },
        { title: this.$t('通用.文本.操作'), dataIndex: 'operation', scopedSlots: { customRender: 'operation' } }
      ]
    }
  },
  created() {
    this.getCourseList()
  },
  watch: {
    visible: {
      handler(newVal) {
        if (newVal && this.courseId) {
          this.queryParam.courseId = this.courseId
          this.getList()
        }
      }
    },
    list: {
      handler(newVal) {
        this.chapterList = newVal
      }
    }
  },
  methods: {
    getCourseList() {
      listLiveCourse({}).then(response => {
        this.courseList = response.data
      })
    },
    getList() {
      this.loading = true
      pageLiveCourseChapter(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = { 
        courseId: this.courseId,
        chapterName: undefined,
        pageNum: 1, 
        pageSize: 10 
      }
      this.handleQuery()
    },
    handleDelete(row) {
      const that = this
      this.$confirm({
        title: this.$t('通用.文本.确认删除'),
        content: this.$t('通用.文本.删除确认数据'),
        onOk() {
          const ids = row.id || that.selectedRowKeys
          delLiveCourseChapter(Array.isArray(ids) ? ids.map(id => ({ id })) : [{ id: ids }]).then(() => {
            that.getList()
            that.$message.success(that.$t('通用.文本.删除成功'))
          })
        }
      })
    },
    handleSection(row) {
      this.selectedChapterId = row.id
      this.sectionModalVisible = true
    },
    handleCancel() {
      this.$emit('cancel')
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
      this.multiple = !selectedRowKeys.length
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    }
  }
}
</script>